<template>
	<div class="h-100">
		<vuestic-layout v-layout>
			
			<app-navbar :isOpen="opened" :userData="user" @toggle-menu="toggleSidebar" />
			
			<app-sidebar :isOpen="opened" @toggle-menu="toggleSidebar" />

			<main slot="content" id="content" class="content" role="main">
				<app-breadcrumbs />

				<vuestic-pre-loader v-show="isLoading" class="pre-loader"></vuestic-pre-loader>

				<!-- <transition name="router-anim"> -->
					<router-view></router-view>
				<!-- </transition> -->

			</main>
		</vuestic-layout>
		<div class="container">
			<div class="text-center offset-md-2 pl-5 footer" slot="footer"><a href="https://zptdigital.com.br/" target="_blank">ZPTDigital ©{{ new Date().getFullYear() }}</a>.</div>
		</div>
	</div>
</template>

<script>
import VuesticLayout from '../../vuestic-theme/vuestic-components/vuestic-layout/VuesticLayout'
import AppNavbar from './app-navbar/AppNavbar'
import AppSidebar from './app-sidebar/AppSidebar'
import AppBreadcrumbs from './app-breadcrumbs/AppBreadcrumbs'
import Layout from 'vuestic-theme/vuestic-directives/Layout'
import { globalStore } from '@/services/userService'
import { mapGetters } from 'vuex'

export default {
	name: 'app-layout',
	props: {
	},
	components: {
		VuesticLayout,
		AppNavbar,
		AppSidebar,
		AppBreadcrumbs
	},
	directives: {
		layout: Layout,
	},
	data() {
		return {
			opened: true,
			user : globalStore.getUser()
		}
	},
	methods: {
		toggleSidebar(opened) {
			this.opened = opened
		}
	},
	computed: {
		...mapGetters([
		'isLoading'
		])

	},
	created: function() {
		this.toggleSidebar(false);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AppLayout.vue